/* LAYOUT */
export const CHANGE_LAYOUT = "CHANGE_LAYOUT";

// topbar
export const CHANGE_TOPBAR_THEME = "CHANGE_TOPBAR_THEME";

// left sidebar
export const TOGGLE_LEFTMENU = "TOGGLE_LEFTMENU";
